import React, { useContext, useEffect, useState } from 'react'
import Application from "../../StateContext/Application";
const Report = () => {
    const statecalls = useContext(Application);
    const { GetReport } = statecalls;
    const [reportData, SetReportData] = useState([]);

    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    useEffect(() => {
        AllReportData();
    }, []);

    async function AllReportData() {
        try {
            let data = await GetReport();
            console.log(data);
            
            SetReportData(data);
            setFilteredBills(data);
        } catch (error) {
            console.error(error);
        }
    }
    return (
        <div>
           <div style={{display:"flex",justifyContent:"center"}}>
           <h3>Report</h3>
           </div>

            <div style={{ padding: "50px" }}>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Sr.no.</th>
                            <th>Date</th>
                            <th>Description</th>
                            <th>Cheque No.</th>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th>Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        { currentBills.map((e, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * billsPerPage + index + 1}</td>
                                        <td>{e.Date?.split('.')[0].replace('T', ' ')}</td>
                                        <td>{e.Description}</td>
                                        <td>{e.Cheque_No==null?"--":e.Cheque_No}</td>
                                        <td>{e.Debit==null?"--":e.Debit}</td>
                                        <td>{e.Credit==null?"--":e.Credit}</td>
                                        <td>{e.Balance}</td>
                                        
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
                <div>
                    <p style={{ margin: '0px', color: 'black' }}>Showing {filteredBills?.length} of {reportData?.length} entries</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* First Page Button */}
                    <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                        &laquo;
                    </button>
                    {/* Previous Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &lt;
                    </button>

                    <button
                        style={{background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                    </button>
                    {/* Next Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &gt;
                    </button>
                    {/* Last Page Button */}
                    <button
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &raquo;
                    </button>
                </div>

            </div>
        </div>
    )
}

export default Report
